import { FC } from 'react'

import { useAtom } from 'jotai'
import {
  Text,
  GreyGrey70,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { isBccVisibleAtom, isCcVisibleAtom } from './emailForm.atoms'

export const FieldToggles: FC = () => {
  const [isCcVisible, setIsCcVisible] = useAtom(isCcVisibleAtom)
  const [isBccVisible, setIsBccVisible] = useAtom(isBccVisibleAtom)

  return (
    <Flex gap="8px">
      {!isCcVisible && (
        <Text
          as="button"
          data-testid="automations.editor.configForm.reminder.email.toggleCc"
          {...Primary13Regular}
          color={GreyGrey70}
          onClick={() => setIsCcVisible(true)}
        >
          CC
        </Text>
      )}
      {!isBccVisible && (
        <Text
          as="button"
          data-testid="automations.editor.configForm.reminder.email.toggleBcc"
          {...Primary13Regular}
          color={GreyGrey70}
          onClick={() => setIsBccVisible(true)}
        >
          BCC
        </Text>
      )}
    </Flex>
  )
}
